// extracted by mini-css-extract-plugin
module.exports = {"banner":"style__banner__A1J50","icon":"style__icon__iyAXM","text":"style__text__A1Bzc","title":"style__title__GoJ6I","count":"style__count__dyu1V","flexit":"style__flexit__aAqoo"};